import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Manifesto", href: "#manifesto" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#enquiry" },
];

export const scrollToSection = (href) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(href, { offset: -70, duration: 1.4 });
  } else {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  }
};

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    scrollToSection(href);
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#09090b]/85 backdrop-blur-xl border-b border-[rgba(212,175,55,0.2)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => go("#home")}
          className="flex items-center group"
          aria-label="SK Media Events home"
        >
          <img
            src="/sk-logo-gold.png"
            alt="SK Media Events"
            className="h-12 w-auto group-hover:scale-105 transition-transform duration-500"
          />
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className="text-xs uppercase tracking-[0.25em] text-zinc-400 hover:text-[#d4af37] transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta-plan-event"
            onClick={() => go("#enquiry")}
            className="text-xs uppercase tracking-[0.2em] px-6 py-3 border border-[rgba(212,175,55,0.5)] text-[#f3e5ab] hover:bg-[#d4af37] hover:text-[#09090b] transition-colors duration-300"
          >
            Plan Your Event
          </button>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-[#d4af37]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden bg-[#0d0d10]/95 backdrop-blur-xl border-t border-[rgba(212,175,55,0.2)] px-6 py-6 flex flex-col gap-5"
        >
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className="text-left text-sm uppercase tracking-[0.25em] text-zinc-300 hover:text-[#d4af37]"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-cta"
            onClick={() => go("#enquiry")}
            className="mt-2 text-xs uppercase tracking-[0.2em] px-6 py-3 border border-[rgba(212,175,55,0.5)] text-[#f3e5ab]"
          >
            Plan Your Event
          </button>
        </div>
      )}
    </header>
  );
}
